import { when } from '@execonline-inc/maybe-adapter';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { AlreadyTranslatedText, NotYetTranslatedText } from '../../Translations';
import AccordionArrowDown from '../Cutesies/AccordionArrowDown';
import AccordionArrowUp from '../Cutesies/AccordionArrowUp';
import AccordionToggleStore from './Store';
import Title from './Title';

interface Props {
  title?: AlreadyTranslatedText | NotYetTranslatedText;
  titleIcon?: React.ReactNode;
  headerInfo?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
  titleJSX?: React.ReactNode;
  openByDefault?: boolean;
  rightIcon?: React.ReactNode;
}

class Accordion extends React.Component<Props> {
  accordionToggleStore: AccordionToggleStore = new AccordionToggleStore();

  componentDidMount(): void {
    if (this.props.openByDefault) {
      this.accordionToggleStore.open();
    }
  }

  render() {
    return (
      <>
        <div className={this.props.className || 'flex items-center justify-between px-7 py-4'}>
          <div className="flex w-full justify-between">
            <div className="flex">
              <div className="flex items-center mr-2">{this.props.titleIcon || <></>}</div>
              {this.props.titleJSX || (
                <p className="grow text-sm font-semibold">
                  <Title title={this.props.title} />
                </p>
              )}
            </div>
            <div className="flex items-center">
              {this.props.headerInfo ? <div className="mr-4">{this.props.headerInfo}</div> : <></>}
            </div>
          </div>
          <div className="flex justify-center items-center gap-8">
            <span>
              {when(this.accordionToggleStore.isOpen, true)
                .map(() => (
                  <button
                    onClick={this.accordionToggleStore.close}
                    className="h-4 cursor-pointer"
                    aria-label="Collapse section"
                  >
                    <AccordionArrowUp />
                  </button>
                ))
                .getOrElse(() => (
                  <button
                    onClick={this.accordionToggleStore.open}
                    className="h-4 cursor-pointer"
                    aria-label="Expand section"
                  >
                    <AccordionArrowDown />
                  </button>
                ))}
            </span>
            {this.props.rightIcon}
          </div>
        </div>
        <div className={clsx(this.accordionToggleStore.isOpen ? 'block h-full' : 'hidden h-0')}>
          {this.props.children}
        </div>
      </>
    );
  }
}

export default observer(Accordion);
